(() => {
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  const section = document.querySelector('[data-scroll-video]');
  const video = section?.querySelector('.cinema-video');
  const endframe = section?.querySelector('.cinema-endframe');
  const scenes = [...document.querySelectorAll('.scene')];
  let mediaReady = false;
  let targetTime = 0;
  let seekPending = false;
  let lastApplied = -1;

  function setSceneProgress(progress) {
    const ranges = [
      [0.00, 0.36],
      [0.26, 0.72],
      [0.62, 1.00],
    ];

    scenes.forEach((scene, i) => {
      const [start, end] = ranges[i] || [0, 1];
      const local = clamp((progress - start) / (end - start), 0, 1);
      const fadeIn = start === 0 ? 1 : clamp(local / 0.25, 0, 1);
      const fadeOut = end === 1 ? 1 : clamp((1 - local) / 0.25, 0, 1);
      const opacity = Math.min(fadeIn, fadeOut);
      const y = (1 - fadeIn) * 70 - (1 - fadeOut) * 50;
      scene.style.opacity = opacity.toFixed(3);
      scene.style.transform = `translateY(${y}px)`;
    });
  }

  function getProgress() {
    if (!section) return 0;
    const rect = section.getBoundingClientRect();
    const max = section.offsetHeight - window.innerHeight;
    return clamp(-rect.top / Math.max(max, 1), 0, 1);
  }

  function doSeek() {
    if (!video || !mediaReady || !Number.isFinite(video.duration) || video.duration <= 0) return;
    const safeTarget = clamp(targetTime, 0, Math.max(video.duration - 0.04, 0));

    if (Math.abs(safeTarget - lastApplied) < 0.025) return;

    // The tutorial pattern: do not hammer the decoder while it is already seeking.
    if (video.seeking) {
      seekPending = true;
      return;
    }

    try {
      lastApplied = safeTarget;
      video.currentTime = safeTarget;
    } catch (error) {
      console.warn('scroll video seek failed', error);
    }
  }

  function updateScrollVideo() {
    const progress = getProgress();
    if (video && Number.isFinite(video.duration) && video.duration > 0) {
      targetTime = progress * Math.max(video.duration - 0.04, 0);
      doSeek();
    }
    setSceneProgress(progress);
    if (endframe) {
      // Keep the real final generated still visible at the end instead of letting the stream snap back to frame 1.
      endframe.style.opacity = String(clamp((progress - 0.965) / 0.025, 0, 1));
    }
    updateDebug(progress);
  }

  function initVideo() {
    if (!video) return;
    const hlsUrl = video.dataset.hls;
    const mp4Url = video.dataset.mp4;

    video.muted = true;
    video.playsInline = true;
    video.preload = 'auto';

    const markReady = () => {
      mediaReady = true;
      video.style.display = 'block';
      // Prime decoders on muted media, then keep scroll in control.
      video.play().then(() => video.pause()).catch(() => {});
      updateScrollVideo();
    };

    if (window.Hls && window.Hls.isSupported() && hlsUrl) {
      const hls = new Hls({
        maxBufferLength: 120,
        maxMaxBufferLength: 600,
        maxBufferSize: 200 * 1024 * 1024,
        startPosition: 0,
        capLevelToPlayerSize: false,
        startLevel: -1,
        autoStartLoad: true,
        enableWorker: true,
      });
      window.__wgHls = hls;
      hls.attachMedia(video);
      hls.on(Hls.Events.MEDIA_ATTACHED, () => hls.loadSource(hlsUrl));
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        // Keep auto quality for local prototype; forced levels can break if no variants exist.
        markReady();
      });
      hls.on(Hls.Events.FRAG_BUFFERED, () => {
        mediaReady = true;
        updateScrollVideo();
      });
      hls.on(Hls.Events.ERROR, (_, data) => console.warn('hls error', data));
    } else if (video.canPlayType('application/vnd.apple.mpegurl') && hlsUrl) {
      video.src = hlsUrl;
      video.addEventListener('loadedmetadata', markReady, { once: true });
    } else if (mp4Url) {
      video.src = mp4Url;
      video.addEventListener('loadedmetadata', markReady, { once: true });
    }

    video.addEventListener('canplay', markReady);
    video.addEventListener('seeked', () => {
      if (seekPending) {
        seekPending = false;
        doSeek();
      }
    });
    video.addEventListener('error', () => {
      console.warn('video error', video.error);
      if (!Number.isFinite(video.duration) || video.duration <= 0) video.style.display = 'none';
    });
  }

  let ticking = false;
  let lastScrollY = window.scrollY;
  const header = document.querySelector('.site-header');

  function updateSmartHeader() {
    if (!header || !section) return;
    const currentY = window.scrollY;
    const delta = currentY - lastScrollY;
    const pastVideo = currentY > (section.offsetTop + section.offsetHeight - window.innerHeight * 0.55);

    if (!pastVideo || currentY < 80) {
      header.classList.remove('is-smart-hidden');
    } else if (delta > 6) {
      header.classList.add('is-smart-hidden');
    } else if (delta < -6) {
      header.classList.remove('is-smart-hidden');
    }

    lastScrollY = currentY;
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateScrollVideo();
      updateSmartHeader();
      ticking = false;
    });
  }

  function updateDebug(progress) {
    if (!window.location.search.includes('debug')) return;
    let el = document.querySelector('.scroll-debug');
    if (!el) {
      el = document.createElement('pre');
      el.className = 'scroll-debug';
      Object.assign(el.style, {
        position: 'fixed', left: '12px', bottom: '12px', zIndex: 9999,
        background: 'rgba(0,0,0,.82)', color: '#8dffb0', padding: '10px 12px',
        border: '1px solid rgba(255,255,255,.2)', borderRadius: '10px', font: '12px monospace',
        pointerEvents: 'none', maxWidth: '360px'
      });
      document.body.appendChild(el);
    }
    const seek = video?.seekable?.length ? `${video.seekable.start(0).toFixed(2)}-${video.seekable.end(0).toFixed(2)}` : 'none';
    el.textContent = `scroll ${Math.round(window.scrollY)}\nprogress ${progress.toFixed(3)}\ntime ${video?.currentTime?.toFixed(2)} / ${video?.duration?.toFixed(2)}\ntarget ${targetTime.toFixed(2)}\nready ${video?.readyState} seeking ${video?.seeking}\nseekable ${seek}\nhls ${!!window.__wgHls}`;
  }

  initVideo();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  updateScrollVideo();
  updateSmartHeader();

  const revealItems = [...document.querySelectorAll('.section > *, .feature-grid article, .course-card')];
  revealItems.forEach(el => el.classList.add('is-hidden'));
  const io = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.remove('is-hidden');
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.14 });
  revealItems.forEach(el => io.observe(el));

  function parseGermanDate(dateRange) {
    const last = dateRange.match(/(\d{1,2})\.(\d{2})\.(\d{4})/);
    if (!last) return 0;
    return new Date(Number(last[3]), Number(last[2]) - 1, Number(last[1])).getTime();
  }

  function parseCourseDatesFromHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('script,style,noscript,svg').forEach(el => el.remove());
    const text = (doc.body?.innerText || doc.body?.textContent || '')
      .replace(/\s+/g, ' ')
      .replace(/\s*–\s*/g, '–')
      .trim();
    const datePattern = /\d{1,2}\.\s*[–-]\s*\d{1,2}\.\d{2}\.\d{4}/g;
    const seen = new Set();
    const items = [];
    for (const match of text.matchAll(datePattern)) {
      const date = match[0].replace(/\s+/g, '').replace('-', '–');
      const before = text.slice(Math.max(0, match.index - 260), match.index).toLowerCase();
      const after = text.slice(match.index, match.index + 260);
      const immediate = after.slice(match[0].length, match[0].length + 80).toLowerCase();
      const sportsIndex = before.lastIndexOf('sportschütz');
      const bewacherIndex = before.lastIndexOf('bewacher');
      const immediateSports = immediate.indexOf('sportschütz');
      const immediateBewacher = immediate.indexOf('bewacher');
      const label = immediateBewacher >= 0 && (immediateSports < 0 || immediateBewacher < immediateSports) ? 'Bewacher'
        : immediateSports >= 0 ? 'Sportschützen'
        : bewacherIndex > sportsIndex ? 'Bewacher'
        : sportsIndex >= 0 ? 'Sportschützen'
        : 'Waffensachkunde';
      const deadline = after.match(/Anmeldeschluss\s*(\d{1,2}\.\d{1,2}\.\d{4})/i)?.[1] || '';
      const key = `${label}-${date}-${deadline}`;
      if (seen.has(key)) continue;
      seen.add(key);
      items.push({ label, date, deadline, time: parseGermanDate(date) });
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const upcoming = items.filter(item => !item.time || item.time >= today.getTime()).sort((a, b) => a.time - b.time);
    return (upcoming.length ? upcoming : items).slice(0, 4);
  }

  function renderCourseDates(items) {
    const list = document.querySelector('[data-dates-source]');
    if (!list || items.length < 2) return;
    list.innerHTML = items.map(item => `
      <div>
        <span>${item.label}</span>
        <b>${item.date}</b>
        <small>${item.deadline ? `Anmeldeschluss ${item.deadline}` : 'Details auf der Schulungsseite'}</small>
      </div>
    `).join('');
    list.dataset.datesLoaded = 'auto';
  }

  function buildDateSources(source) {
    const bust = `_dates=${Date.now()}`;
    const sameOriginUrl = new URL(source, window.location.origin);
    sameOriginUrl.search += sameOriginUrl.search ? `&${bust}` : `?${bust}`;

    const isLocalPreview = ['127.0.0.1', 'localhost'].includes(window.location.hostname);
    if (!isLocalPreview) return [sameOriginUrl.href];

    const liveUrl = new URL(source, 'https://waffenhandel-goettingen.com');
    liveUrl.search += liveUrl.search ? `&${bust}` : `?${bust}`;
    return [
      `https://api.allorigins.win/raw?url=${encodeURIComponent(liveUrl.href)}`,
      sameOriginUrl.href
    ];
  }

  async function loadCourseDates() {
    const list = document.querySelector('[data-dates-source]');
    const source = list?.dataset.datesSource;
    if (!source) return;
    for (const url of buildDateSources(source)) {
      try {
        const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin' });
        if (!response.ok) continue;
        const html = await response.text();
        const items = parseCourseDatesFromHtml(html);
        if (items.length >= 2) {
          renderCourseDates(items);
          return;
        }
      } catch (_) {
        // Try the next source, then keep the static fallback visible.
      }
    }
  }

  loadCourseDates();

  const leadForm = document.querySelector('#termin-formular');
  leadForm?.querySelector('button')?.addEventListener('click', () => {
    const fd = new FormData(leadForm);
    const interests = fd.getAll('interest').join(', ') || 'nicht ausgewählt';
    const body = [
      'Hallo Waffenhandel Göttingen,',
      '',
      'ich habe eine Anfrage zur Waffensachkunde.',
      '',
      `Name: ${fd.get('name') || ''}`,
      `Kontakt: ${fd.get('contact') || ''}`,
      `Bereich: ${interests}`,
      `Anmerkung: ${fd.get('message') || ''}`,
      '',
      'Viele Grüße'
    ].join('\n');
    window.location.href = `mailto:info@waffenhandel-goettingen.com?subject=${encodeURIComponent('Anfrage Waffensachkunde')}&body=${encodeURIComponent(body)}`;
  });
})();
